import PropTypes from 'prop-types';
import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { Link, useFetcher } from 'react-router-dom';
import styles from '../../../../components/project/project-item.module.scss';
import { Image, MakeArtworkRecievedFiles, Modal, ViewAndDownload } from '../../../../components/ui';
import { FilePreview } from '../../../../components/ui/file-preview.jsx';
import i18n from '../../../../i18n.js';
import { ItemOrderStatus, getSecuredFileUrl } from '../../../../library/constants';
import { generateRouteUrl } from '../../../../library/constants/routes.jsx';
import { DifferenceBetweenDates, formatDate, subtractDaysFromDate } from '../../../../library/utilities';
import style from '../../client-artwork.module.scss';

const ARTWROK_BUFFER_DAYS = 18

const getPreviewUrl = (file) => {
    const extention = file.split('.').pop()

    switch (extention) {
        case "svg":
            return getSecuredFileUrl(file)
        case "pdf":
            return "/icons/filetypes/pdf.svg"

        default:
            return "/icons/filetypes/file.svg"
    }
}

const ArtworkThumbnail = ({ name, url, comment, quotationToken }) => (
    <div className={style.file} key={name}>
        <Image src={getPreviewUrl(url)} width="100" className={style.historyImg} />
        <p className="label">{name}</p>
        <div style={{ 'width': '25%' }}>
            <p>{comment}</p>
        </div>

        <div style={{ 'width': '20%' }}>
            <div className={`actions--compact ${style.artworkActions}`}>
                <ViewAndDownload quotationToken={quotationToken} url={url} />
            </div>
        </div>
    </div>
)
ArtworkThumbnail.propTypes = {
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    comment: PropTypes.string.isRequired,
    quotationToken: PropTypes.string.isRequired,
}

const UploadArtwork = ({ quotationToken, item, style }) => {
    const { t } = useTranslation();
    const fetcher = useFetcher()
    const [isTemplateModalVisuble, setIsTemplateModalVisible] = useState(false)
    const requestedDeliveryDeadline = item.client_expected_delivery_date ? formatDate(item.client_expected_delivery_date) : i18n.t('time')
    const artworkUploadDeadline = item.deadline_artwork_customer ? formatDate(item.deadline_artwork_customer) : formatDate(subtractDaysFromDate(item.client_expected_delivery_date, ARTWROK_BUFFER_DAYS))
    const daysLeft = item.deadline_artwork_customer ?
        DifferenceBetweenDates(Date.now(), item.deadline_artwork_customer) :
        item.client_expected_delivery_date ?
            DifferenceBetweenDates(Date.now(), subtractDaysFromDate(item.client_expected_delivery_date, ARTWROK_BUFFER_DAYS)) :
            null
    const canSendArtwork = item.order_status !== ItemOrderStatus.MAKE_ARTWORK_BY_LP

    const CalendarIcon = ({ daysLeft }) => {
        return (
            <svg width="50" height="50" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="5" width="16" height="12" stroke="#23B17C" strokeWidth="0.7" rx="2" />
                <path d="M13.2456 1V4.42843M6.38873 1V4.42843" stroke="#23B17C" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 5.83429H17.6343" stroke="#23B17C" strokeWidth="0.7" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    
                {/* Days Left Inside Calendar */}
                <text x="10" y="14" textAnchor="middle" fontSize="6" fill="#23B17C" fontWeight="bold">
                    {daysLeft}
                </text>
            </svg>
        );
    };


    return <div className={`box--white ${styles.projectItem}`} style={style} >
        <div className={`box--plain ${styles.tasksBox}`}>
            <h2>{t('Tasks for you')}</h2>
            {item.order_status === ItemOrderStatus.MAKE_ARTWORK_BY_LP &&
                <MakeArtworkRecievedFiles quotationToken={quotationToken} comment={item.make_artwork_comment} documents={item.documents.make_arwork} itemId={item.id} />
            }

            {item.request_for_template === 1 && (
                <div className={`box--light-red ${styles.task}`}>
                    {t('Leoprinting has been requested to send a template.')}
                </div>
            )}
            {item.request_for_template === 2 && (
                <div className={`box--light-red ${styles.task}`}>
                    <div className={styles.taskContent}>
                        {t('Leoprinting has shared the template')}
                    </div>
                    <div className={styles.taskAction}>
                        <button onClick={() => setIsTemplateModalVisible(true)} className="button--primary" >{t("View Template")}</button>
                    </div>
                </div>
            )}
            <div className={`${item.client_expected_delivery_date ? 'box--blue-light' : 'box--light-red'} ${styles.task}`}>
                <div className={styles.taskContent}>
                    {!item.client_expected_delivery_date ? (
                        <span>
                            {/* <Trans
                                defaults="Expected delivery on <0>{{delivery_deadline}}</0> if artwork is uploaded latest by <0>{{artwork_deadline}}</0>"
                                values={{ delivery_deadline: requestedDeliveryDeadline, artwork_deadline: artworkUploadDeadline }}
                                components={[<strong key="date">date</strong>]}
                            /> */}
                        </span>
                    ) : <>{t("Please upload the artwork as soon as possible to avoid any delays in delivery.")}</>}
                    {!!daysLeft && (
                        <div className={styles.daysLeftBox}>
                            <CalendarIcon daysLeft={daysLeft} />
                            <div className={styles.daysLeftSuffix}>{t('Days Left')}</div>
                            <div className={styles.daysLeftText}>{t('to confirm the proof')}</div>
                        </div>
                    )}
                </div>
                <div className={styles.taskAction}>
                    {canSendArtwork && (
                        <>
                            {!item.request_for_template && (
                                <fetcher.Form method="post">
                                    <input type="hidden" name="action" value="requestartworksample" />
                                    <input type="hidden" name="itemId" value={item.id} />
                                    <button type="submit" className="button--primary" >{t('Request Artwork Template')}</button>
                                </fetcher.Form>
                            )}

                            <Link to={generateRouteUrl('ClientArtwork', {
                                quotationToken,
                                itemId: item.id,
                            })} className="button--primary" >{t('Upload Artwork')}</Link>

                        </>
                    )}
                </div>
            </div>
            {item.client_confirm_address === null ? (
                <div className={`box--blue-light ${styles.task}`}>
                    <div className={styles.taskContent}>
                        <span>{t('Fill in the delivery address and confirm ?')}</span>
                    </div>
                    <div className={styles.taskAction}>
                        <Link to={generateRouteUrl('ProjectItemAddress', {
                            quotationToken,
                            itemId: item.id
                        })} className="button--primary" >{t('Add Address')}</Link>
                    </div>
                </div>
            ) : (
                <div className={`box--blue-light ${styles.task}`}>
                    <div className={styles.taskContent}>
                        {t('Delivery Address is already confirmed')}
                    </div>
                    <div className={styles.taskAction}>
                        <Link to={generateRouteUrl('ProjectItemAddress', {
                            quotationToken,
                            itemId: item.id
                        })} className="button--primary" >{t('View Address')}</Link>
                    </div>
                </div>
            )}

        </div>
        <Modal
            title={t('Recieved Templates')}
            onClose={() => { setIsTemplateModalVisible(false) }}
            isVisible={isTemplateModalVisuble}
            closeButtonText={t('Close')}>
            <div>
                {!!item.template_comment && (
                    <>
                        <strong>Comment</strong>: {item.template_comment}
                    </>
                )}
                {!!item?.documents?.template &&
                    item.documents.template.map(file => (
                        <FilePreview key={file.url} name={file.name} path={file.url} comment={file.comment} quotationToken={quotationToken} />
                    ))
                }
            </div>
        </Modal>
    </div >
}
UploadArtwork.propTypes = {
    quotationToken: PropTypes.string.isRequired,
    item: PropTypes.shape({
        id: PropTypes.number,
        product: PropTypes.shape({
            name: PropTypes.string.isRequired,
            main_photos: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        deadline_artwork_customer: PropTypes.string,
        order_status: PropTypes.number,
        client_expected_delivery_date: PropTypes.string,
        make_artwork_comment: PropTypes.string,
        request_for_template: PropTypes.number,
        client_confirm_address: PropTypes.number,
        template_comment: PropTypes.string,
        documents: PropTypes.object,
    })
}
export default UploadArtwork